var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_c('i',{staticClass:"el-icon-data-board",style:({ marginRight: '5px', color: '#0027ff' })}),_vm._v("任务概况")])]),_c('froala-views',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }